/**
 * Image/video caption component.
 * Customized to apply glossary tooltips on the description text.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { TextWithGlossaryTooltips } from '@rohberg/volto-slate-glossary/utils';

const Caption = ({ as = 'figcaption', title, description, credit }) => {
  const As = as;
  return (
    <As>
      {title && <h2 className="title">{title}</h2>}
      {description && (
        <div className="description">
          {description.split('\n').map((line, index) => (
            <p key={index}>
              {line ? <TextWithGlossaryTooltips text={line} /> : '\u00A0'}
            </p>
          ))}
        </div>
      )}
      {credit && <p className="credits">{credit}</p>}
    </As>
  );
};

Caption.propTypes = {
  credit: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Caption;
